import axios        from 'axios';
import authHeader   from 'services/auth-header';

class ReferralService  {
  referrals(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'referees', { headers: authHeader(), params: params })
      .then(response => {
        return response.data;
      }
    );
  }

  referrers(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'referrers', { headers: authHeader(), params: params })
      .then(response => {
        return response.data;
      }
    );
  }

  specialties() {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'specialties', { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  doctors(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'doctors', { headers: authHeader(), params: params })
      .then(response => {
        return response.data;
      }
    );
  }

  uploadReferralLetter(file) {
    var formData = new FormData();
    formData.append("file", file);
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'referral_letters', formData, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  submitReferral(params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'referrals', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  suggestDoctor(params) {
  //   PARAMS = {
  //     "referral_letter_id": null,
  //     "patient_name": "Testing Three",
  //     "specialty_id": 16,
  //     "patient_email": "yapyw@bookdoc.com",
  //     "patient_phone_number": "12312312312",
  //     "note": null,
  //     "name": "Doctor Not In DB Two",
  //     "practice_location": "Test Location Two"
  // }
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'referrals/suggest_doctor', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new ReferralService();